var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedeemGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 20.3789H7.85237C9.12822 20.3789 10.3518 20.8857 11.254 21.7879C12.1561 22.6901 12.663 23.9136 12.663 25.1895",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89026 25.1895H16.5114C17.5321 25.1895 18.511 25.5949 19.2327 26.3166C19.9544 27.0384 20.3599 28.0172 20.3599 29.0379C20.3599 29.2931 20.2585 29.5378 20.0781 29.7182C19.8977 29.8987 19.6529 30 19.3978 30H4.00391",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.543,
    y: 11.2731,
    width: 14.6824,
    height: 8.50034,
    fill: "#F7BFCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9102 19.9749H25.5469C25.9988 19.9749 26.3652 19.6085 26.3652 19.1567V11.7927",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.47454C10 8.04776 10.346 7.70178 10.7728 7.70178H27.228C27.6547 7.70178 28.0007 8.04776 28.0007 8.47454V11.0201C28.0007 11.4469 27.6547 11.7929 27.228 11.7929H10.7728C10.346 11.7929 10 11.4469 10 11.0201V8.47454Z",
    fill: "#F7BFCC",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9961 19.975V7.70178",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6513 5.38783C22.2803 6.46298 20.7062 7.25003 19.0234 7.70174C19.4752 6.01903 20.2622 4.44493 21.3373 3.07392C22.7763 1.63605 23.5913 1.85642 24.2349 2.49572C24.8786 3.13502 25.0902 3.94996 23.6513 5.38783Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3477 5.38783C15.7188 6.46278 17.2929 7.24981 18.9755 7.70174C18.5243 6.01883 17.7372 4.44463 16.6616 3.07392C15.2237 1.63605 14.4088 1.85642 13.7651 2.49572C13.1215 3.13502 12.9098 3.94996 14.3477 5.38783Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9102 19.9749H12.4555C12.0036 19.9749 11.6373 19.6085 11.6373 19.1567V11.7927",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemGift);
export default __webpack_public_path__ + "static/media/redeem-gift.9ba3e535bef92d4fb24595e6d49bc415.svg";
export { ForwardRef as ReactComponent };